import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Check, Calendar, Users, Video, BookOpen } from 'lucide-react';
import { FadeIn } from './ui/FadeIn';
export function MentorshipSection() {
  const navigate = useNavigate();
  const inclusions = [{
    icon: <BookOpen size={18} data-id="element-211" />,
    text: 'Lenguaje de Precio'
  }, {
    icon: <BookOpen size={18} data-id="element-212" />,
    text: 'Ebook Protocolo Sniper OTC'
  }, {
    icon: <BookOpen size={18} data-id="element-213" />,
    text: 'Tu Yo Perfecto para el Trading'
  }, {
    icon: <Video size={18} data-id="element-214" />,
    text: 'Clases en vivo + grabadas'
  }, {
    icon: <Check size={18} data-id="element-215" />,
    text: 'Correcciones en vivo con capturas'
  }, {
    icon: <Users size={18} data-id="element-216" />,
    text: 'Q&A y Comunidad privada (3 meses)'
  }, {
    icon: <Check size={18} data-id="element-217" />,
    text: 'Bonus final: Puente a Futuros (1–2 clases)'
  }];
  return <section id="mentoria" className="py-24 md:py-32 bg-neutral-900 relative" data-id="element-218">
      {/* Background grid pattern */}
      <div className="absolute inset-0 bg-[linear-gradient(to_right,#1c1c1c_1px,transparent_1px),linear-gradient(to_bottom,#1c1c1c_1px,transparent_1px)] bg-[size:4rem_4rem] [mask-image:radial-gradient(ellipse_60%_50%_at_50%_50%,#000_70%,transparent_100%)] opacity-20 pointer-events-none" data-id="element-219" />

      <div className="max-w-5xl mx-auto px-6 md:px-12 relative z-10" data-id="element-220">
        <FadeIn data-id="element-221">
          <div className="border border-red-600/30 bg-[#0f0f0f] rounded-sm relative shadow-[0_0_40px_rgba(220,38,38,0.05)]" data-id="element-222">
            {/* Top accent line */}
            <div className="absolute top-0 left-0 w-full h-[2px] bg-gradient-to-r from-transparent via-red-600 to-transparent" data-id="element-223" />

            <div className="p-8 md:p-12 lg:p-16" data-id="element-224">
              <div className="flex flex-col md:flex-row md:items-center justify-between gap-6 mb-10" data-id="element-225">
                <div data-id="element-226">
                  <span className="text-xs font-bold tracking-[0.2em] text-red-500 uppercase mb-3 block" data-id="element-227">
                    Programa Principal
                  </span>
                  <h2 className="text-3xl md:text-4xl font-black text-white tracking-tight uppercase mb-4" data-id="element-228">
                    Mentoría Privada
                    <br data-id="element-229" />
                    Protocolo Sniper
                  </h2>
                  <p className="text-neutral-400 max-w-xl text-balance" data-id="element-230">
                    La opción completa para avanzar con orden, correcciones y
                    comunidad. El objetivo es que salgas con criterio propio{' '}
                    <strong className="text-white font-medium" data-id="element-231">
                      (sin dependencia)
                    </strong>
                    .
                  </p>
                </div>

                <a href="https://ig.me/m/protocolo.sniper" target="_blank" rel="noopener noreferrer" className="bg-neutral-900 border border-neutral-800 hover:border-red-600/40 p-4 rounded-sm shrink-0 flex items-center gap-4 transition-colors cursor-pointer no-underline" data-id="element-232">
                  <div className="w-10 h-10 bg-red-600/10 flex items-center justify-center rounded-sm" data-id="element-233">
                    <Calendar className="text-red-500 w-5 h-5" data-id="element-234" />
                  </div>
                  <div data-id="element-235">
                    <span className="block text-xs text-neutral-500 uppercase tracking-wider font-bold" data-id="element-236">
                      Consultar por DM
                    </span>
                    <span className="block text-white font-bold" data-id="element-237">
                      @PROTOCOLO.SNIPER
                    </span>
                  </div>
                </a>
              </div>

              <div className="w-full h-[1px] bg-neutral-800 mb-10" data-id="element-238" />

              <div className="grid md:grid-cols-2 gap-x-12 gap-y-6 mb-12" data-id="element-239">
                {inclusions.map((item, idx) => <div key={idx} className="flex items-start gap-3" data-id="element-240">
                    <div className="text-red-500 mt-0.5 shrink-0" data-id="element-241">
                      {item.icon}
                    </div>
                    <span className="text-neutral-300 text-sm" data-id="element-242">
                      {item.text}
                    </span>
                  </div>)}
              </div>

              <div className="flex flex-col sm:flex-row items-center justify-between gap-6 bg-neutral-950/50 p-6 border border-neutral-800/50 rounded-sm" data-id="element-243">
                <div className="flex items-center gap-3" data-id="element-244">
                  <div className="w-2 h-2 bg-red-500 rounded-full animate-pulse" data-id="element-245" />
                  <span className="text-sm text-neutral-400 font-medium" data-id="element-246">
                    Cupos limitados (se cierra al completarse).
                  </span>
                </div>
                <button onClick={() => navigate('/mentoria')} className="w-full sm:w-auto bg-red-600 hover:bg-red-500 text-white font-bold py-4 px-10 rounded-sm transition-all text-center uppercase tracking-wider text-sm cursor-pointer" data-id="element-247">
                  Ver Mentoría
                </button>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}